<template lang="pug">
  div
    // Image and text
    b-navbar.quiz-navbar(variant='faded' type='light' fixed='top' :sticky="!sticky")
      b-navbar-brand(href='/quiz')
        img.quiz-brand.d-inline-block.align-top(:src='imgLogo')

</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {}
  },
  props: {
    sticky: {
      type: Boolean,
      default: true,
      required: true
    }
  },
  computed: {
    imgLogo() {
      return require(`@/assets/images/logo.png`)
    }
  }
}
</script>

<style lang="scss" scoped>

.quiz-navbar {
  background: rgb(229, 218, 218, 0.95);
  background: linear-gradient(90deg, rgba(254, 236, 236, 0.80) 0%, rgba(254, 238, 204, 0.80) 50%, rgba(254, 171, 171, 0.80) 100%);
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);

  .quiz-brand {
    width: 50%;

    @include media-breakpoint-up(lg) {
      width: 70%;
      margin-left: 20%;
    }
  }

}
</style>